import styled from '@emotion/styled';
import {Dialog} from '@bosch/react-frok';


export const ContentWrapper = styled.div`
    display: inline-flex;
    flex-wrap: wrap;
`;

export const LabelImage = styled.img`
    width: 120px;
    height: 120px;
    alignment: center;
    padding-right: 30px;
`;

export const LabelFigure = styled.figure`
    display: block;
    margin: 0;
`;

export const LabelRatioWrapper = styled.div`
    position: relative;
    overflow: hidden;
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 10%;
    width: 140px;
    height: 180px;
`;
export const CheckboxContainer = styled.div`
    padding: .75rem;
    display: flex;

    &::before {
        position: relative;
        top: 0;
        left: 0;
        background-color: var(--small__enabled__fill__default);
        content: '';
        display: inline-block;
        height: 1.5rem;
        width: 1.5rem;
    }
`;

export const Label = styled.label`
    display: inline-block;
    width: 100%;
`;

export const LabelItem = styled.label`
    display: inline-block;
    width: 100%;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
`;

export const DialogWrapper = styled(Dialog)`
    overflow: hidden;

    & .m-dialog__headline {
        font-size: 1rem;
        font-weight: 300;
        margin-bottom: 3rem;
    }
`;

